import { Component, EventEmitter, Input, Output } from '@angular/core';

export type WizardStepStatus = 'complete' | 'current' | 'pending' | 'skipped';

/** Presentational step — the parent derives status/clickable from its own step config. */
export interface WizardStepperItem {
  id: string;
  label: string;
  status: WizardStepStatus;
  clickable: boolean;
}

/** Wizard steps bar — visually matches the Create POS stepper card. */
@Component({
  selector: 'app-wizard-stepper',
  standalone: false,
  templateUrl: './wizard-stepper.component.html',
  styleUrl: './wizard-stepper.component.scss',
})
export class WizardStepperComponent {
  @Input({ required: true }) steps: WizardStepperItem[] = [];
  @Input() ariaLabel = 'Wizard progress';
  /** Shows the round "‹" back button on the left of the card. */
  @Input() showBack = false;
  @Output() stepSelect = new EventEmitter<string>();
  @Output() back = new EventEmitter<void>();

  onSelect(step: WizardStepperItem): void {
    if (step.clickable && step.status !== 'current') this.stepSelect.emit(step.id);
  }
}
